import React from 'react';
import PropTypes from 'prop-types';
import { Prompt } from 'react-router-dom';
import { injectIntl } from 'react-intl';

const RoutePrompt = ({ intl, ...otherProps }) => (
  <Prompt
    message={intl.formatMessage({
      id: 'router.unsavedData',
      defaultMessage: 'You have unsaved changes on this page. Do you want to leave this page and discard your changes or stay on this page?',
    })}
    {...otherProps}
  />
);

RoutePrompt.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }).isRequired,
};

export default injectIntl(RoutePrompt);
